var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCarouselCaretLeft = function SvgCarouselCaretLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.957.75a.746.746 0 0 1-.22.53L1.903 5.115a1.25 1.25 0 0 0 0 1.767l3.83 3.83a.749.749 0 1 1-1.06 1.06l-3.83-3.83a2.751 2.751 0 0 1 0-3.887L4.677.22a.75.75 0 0 1 1.28.53Z",
    fill: "#053249"
  })));
};
export default SvgCarouselCaretLeft;